<section *ngIf="blockedCount > 0"
	class="blocked-services-alert-box grid-column-one-full card-block"
	role="alert"
	aria-live="polite">
	<mat-icon svgIcon="alert" class="blocked-services-alert-icon" aria-hidden="true"></mat-icon>
	<div class="blocked-services-alert-content">
		<span class="blocked-services-alert-message">{{ introMessage }}:</span>
		<ul class="blocked-services-chips">
			<li *ngFor="let service of blockedServices"
				class="blocked-service-chip"
				[attr.title]="service.label">
				{{ service.label }}
			</li>
		</ul>
	</div>
	<div class="blocked-services-refresh-button">
		<button type="button" mat-button color="primary" (click)="refresh()" class="refresh-button-label">
			<span translate>blocked-service-alert.refresh</span>
			<mat-icon iconPositionEnd color="accent" svgIcon="refresh"></mat-icon>
		</button>
	</div>
</section>
